import { handleClickForKeyboard } from "simplydo/core/accessibility";

import { RadioCardContent } from "./RadioCard.styles";

export type RadioCardItemProps = {
  children: React.ReactNode;
  value: string;
  selected?: boolean;
  editable?: boolean;
  onClick?: () => void;
};

export const RadioCardItem = ({
  children,
  selected = false,
  editable = true,
  onClick,
}: RadioCardItemProps) => {
  return (
    <RadioCardContent
      role="radio"
      aria-checked={selected}
      tabIndex={0}
      $editable={editable}
      $selected={selected}
      onClick={onClick}
      onKeyDown={handleClickForKeyboard(onClick ?? (() => {}))}
    >
      {children}
    </RadioCardContent>
  );
};
